const initialState = {
  modal: false,
  route: null,
  camera_id: null,
  updated: false,
  deleted: false,
  is_tadbir: false,
  refresh: false
}

const opgModal = (state = initialState, action) => {
  switch (action.type) {
    case "OPG_MODAL_ACTION":
      return { ...state, modal: action.val.modal, route: action.val.route, camera_id: action.val.camera_id, is_tadbir: action.val.is_tadbir }
    case "OPG_UPDATE_DATA":
      return { ...state, updated: action.val }
    case "OPG_DELETED_DATA":
      return { ...state, deleted: action.val }
    case "OPG_REFRESH_DATA":
      return { ...state, refresh: action.val }
    default:
      return state
  }
}

export default opgModal
